import { Component, Inject, ViewChild } from '@angular/core';
import {  Router } from '@angular/router';

import { WireRequestService } from '../../pages/wire-requests/wire-requests.service';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom, interval, Subscription } from 'rxjs';
import {CodeInputComponent} from 'angular-code-input';
import { CustomEncryption } from '../../../config/custom-encrypt';
import { ToasterService } from '../../helpers/toaster.service';
import { ClientTradesService } from '../../pages/recently-viewed-client-list/client-trades.service';
import { StorageServiceAAA } from '../../helpers/aaa-storage.service';
import { CommonService } from '../../helpers/common.service';
import * as CryptoJS from 'crypto-js';
import * as lodash from 'lodash';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';
import { DOCUMENT } from '@angular/common';
declare var cordova: any;
@Component({
	standalone: false,
  selector: 'app-connected-accounts',
  templateUrl: './connected-accounts.component.html',
  styleUrl: './connected-accounts.component.scss',
  providers: [ CommonService, WireRequestService, ClientTradesService]

})
export class ConnectedAccountsComponent {
	hideModel: boolean = false;
	AddmemOverlay: boolean = false;
	ParentClientCode: any;
	MakerId: any;
	selectedClient:any=null;
	TotalValue: any=0;
	externalBrokerList:any = []
	userType: any;
	previousUrl: any;
	clientDetails: any;
	isPartner: any = false;
	isAPPview:any =false;
  constructor(private router: Router,private commonService: CommonService,
		private route: ActivatedRoute,
		private storage: StorageServiceAAA,
		@Inject(DOCUMENT) private document: any,	//Document,
		 private clientService: ClientTradesService,private wireReqService: WireRequestService,
		 private ciphetText: CustomEncryption, public toast: ToasterService,private cookieService: CookieService) { 
			this.cookieService.delete('beyond');
			this.isAPPview = this.commonService.isApp()
		 }
     @ViewChild('codeInput') codeInput !: CodeInputComponent;
	 generatedLink = null;
     displayMemberContent:boolean = true;
     clientId:any;
     otpInput:any;
     memberClientCode:any;
     selectRelation:any;
     tokenValue:any;
     checkOtp:any;
     userIdValue:any;
     dataLoad?:boolean;
     display1:boolean = false;
     display2:boolean = false;
     display3:boolean = false;
     verifyBtn:boolean = true;
     displayTabs:boolean = true;
     jointHolders: any = [];
	 isApkWebView = false;
   
     portfolioToken:any;
     portfolioId:any;
     portfolioUserId:any;
     private subscription: Subscription = new Subscription();
	clientName: any;
	displayClientCode?: string;
	showrefreshlist = null;
	displayRelation = "FAMILY";



  goBack() {
		localStorage.setItem('fromConnected','true')
    	window.history.back();
  }
  showRefresh(i:any) {
	this.showrefreshlist === i ? this.showrefreshlist = null : this.showrefreshlist = i
  }
 async generateLink(){
	if((this.userType == 'RM' || this.userType == 'FN'|| this.userType === 'SB') && this.isPartner == 'true'){

		this.cleverTabAndAppflyerEvent('ExternalPortfolio_GenerateLinkClicked')
	} else {
		this.cleverTabAndAppflyerEvent('Cl_ExternalPortfolio_GenerateLinkClicked')
	}
	
		try {
			const signedToken = await this.generateEdgeToken();
			if (!signedToken) {
				throw new Error('Signed token unavailable');
			}
			const obj=  localStorage.getItem('userId1')
			const res: any = await firstValueFrom(
				this.clientService.generateExternalConnectLinkRm(signedToken,obj,this.isPartner == 'true' ? true:false)
			);
			if(res?.link){
				this.generatedLink = res?.link
				this.hideModel = true
			}

		} catch (error:any){
			this.errorDisplay(error)
		}
	}
	closegeneratelink() {
		this.hideModel = !this.hideModel;
		this.document.querySelector('.tableoverlay').classList.add('d-none');
	}
  onOtpChanged(event: any){
		this.otpInput = event
	}

	onotpFieldCompleted(event: any){
		// const btnEle = document.getElementById('verifyMemberBtn') as HTMLInputElement;
		// btnEle.disabled = false;
		this.verifyBtn = false;
	}

	addMemberForm(){
if(this.isPartner === 'false'){
						this.commonService.setClevertapEvent( 'Addfamilymember_clicked' , 
			{ 'Login ID' : localStorage.getItem('familyListConnected')});
		} else {
			this.commonService.setClevertapEvent('AAA_Addfamilymember_clicked', 
			{ 'Login ID': localStorage.getItem('userId1'), 'Source': 'Connected' });
		}
		this.AddmemOverlay = !this.AddmemOverlay;
		this.display1 = true;
		this.display2 = false;
		this.display3 = false;
		this.otpInput = null;
		this.verifyBtn = true;

	}
	subscribeOtp!: Subscription;
	transform(value: number): string {
		const minutes: number = Math.floor(value / 60);
		return (minutes < 10 ? '0' + minutes : minutes) + ':' + ((value - minutes * 60) < 10 ? '0' + (value - minutes * 60) : (value - minutes * 60))
	}
	resendTimer: any = "01:00";
	resendOtpTimer(){
		this.subscribeOtp = interval(1000).subscribe(res => {
			// this.resendTimer = this.resendTimer - res;
					this.resendTimer = this.transform(60 - res);
					if (res === 60) {
						this.subscribeOtp.unsubscribe();
						this.resendTimer = null
					}
		});
	}

	addMemberFormnext(){
		const element:any  = this.document.getElementById('memberBtn')
		element.disabled=true
		if(this.memberClientCode && this.selectRelation){
			let params = {
				"Type": "Add",
				"FamilyName": this.memberClientCode,
				"MakerID": this.clientId,
				"Relation": this.selectRelation,
				"OTP":  ""
			}
			this.subscription.add(
				this.clientService.getMemberDetails(params,this.portfolioToken)
					.subscribe((res: any) => {
						element.disabled = false
						if(res['Head']['ErrorCode'] == 0){
							if(res['Body']['ClientFamilyMappingDetailsMapp']){
							  let getOtpObj = res['Body']['ClientFamilyMappingDetailsMapp'].filter((obj: any) => obj.ClientCode == this.memberClientCode && obj.Status == 'Inactive');
							   this.checkOtp = getOtpObj?.[0]?.['OTP'];
							   this.resendOtpTimer()
							   localStorage.setItem('saveOtp', this.checkOtp);
							   	this.display1 = false;
								this.display2 = true;
								this.display3 = false;
							 //  this.document.querySelector('.step2').classList.remove('d-none');
							//    const ele1 = document.getElementById('clientIdFrom1') as HTMLInputElement;
							//    ele1.style.display = 'none';
							//    const ele2 = document.getElementById('otpBox1') as HTMLInputElement;
							//    ele2.style.display = 'block';
							}
						
						}
						else if (res['Head']['ErrorCode'] == 1 && res['Head']['ErrorDescription'].includes('already exist')) {
							let alredyExistClientObj = res['Body']['ClientFamilyMappingDetailsMapp'].filter((obj: any) => obj.ClientCode == this.memberClientCode && obj.Status == 'Inactive');
							this.resendOTP()
						}
						else{
							this.toast.displayToast(res['Head']['ErrorDescription']);
						}
					})
			)
		}
		else{
			this.toast.displayToast('Please select input value')
		}
	}

	resetOtpClick(){
		if (this.resendTimer == null) {
			this.resendTimer = "01:00";
			this.resendOtpTimer();
			this.resendOTP('timer');
		}
	}

	resendOTP(otpTimer?: any){
		let params = {
			"Type": "Resend",
			"FamilyName": this.memberClientCode,
			"MakerID": this.clientId,
			"Relation": this.selectRelation,
			"OTP":  ""
		}
		this.subscription.add(
			this.clientService.getMemberDetails(params,this.portfolioToken)
				.subscribe((res: any) => {
					if(res['Head']['ErrorCode'] == 0){
						if(res['Body']['ClientFamilyMappingDetailsMapp']){
						  let getOtpObj = res['Body']['ClientFamilyMappingDetailsMapp'].filter((obj: any) => obj.ClientCode == this.memberClientCode && obj.Status == 'Inactive');
						   this.checkOtp = getOtpObj[0]['OTP'];
						
						   localStorage.setItem('saveOtp', this.checkOtp);
						   if(!otpTimer){
						   this.display1 = false;
						   this.display2 = true;
						   this.display3 = false;
						}
						//    this.document.querySelector('.step2').classList.remove('d-none');
						//    const ele1 = document.getElementById('clientIdFrom1') as HTMLInputElement;
						//    ele1.style.display = 'none';
						}
					
					}
					else{
						this.toast.displayToast(res['Head']['ErrorDescription']);
					}
				})
			)	
	}

	closeForm() {
		// this.document.querySelector('.addmemeberForm1').classList.add('d-none');
		// this.document.querySelector('.tableoverlay').classList.add('d-none');
		this.AddmemOverlay = !this.AddmemOverlay;
		this.resetForm();
		this.getFamilyDropdown()
	}

	resetForm(){
		// const ele1 = document.getElementById('clientIdFrom1') as HTMLInputElement;
		// ele1.style.display = 'block';
		// const ele = document.getElementById('otpBox1') as HTMLInputElement;
		// ele.style.display = 'none';
		this.memberClientCode = null;
		this.selectRelation = null;
		this.otpInput = null;
		this.display1 = true;
		this.display2 = false;
		this.display3 = false;
		this.verifyBtn = true;
		const ele1 = document.getElementById('memberPop') as HTMLInputElement;
		ele1.style.display = 'block';

	}
  ngOnInit() {
		addEventListener("beforeunload", (event) => { 
			this.cookieService.set('isresfreshed','1');
		})
		localStorage.setItem('saveClientId', 'true');
		this.subscription = new Subscription();
		this.route.queryParams.subscribe((params:any) => {
				this.clientId =	params?.['code'];
				this.isPartner = params?.['displayClientDropDownField']
				this.isApkWebView = JSON.parse(params?.['isApkWebView'])
			this.storage.get('userType').then(type => {
			if (type === 'RM') {
				this.userType = type;
			} else if (type === 'FAN') {
				this.userType = 'FN';
			} else {
				this.userType = 'SB';
			}
		})
		if(this.isPartner == 'true'){
			this.storage.get('userType').then(type => {
				if (type === 'RM' || type === 'FAN') {
					this.storage.get('userID').then((userId) => {
						this.storage.get('bToken').then(token => {
							this.portfolioToken = token;
							this.portfolioUserId = this.ciphetText.aesEncrypt(userId);
						
						})
					})
				
				} else {
					this.storage.get('subToken').then(token => {
						this.storage.get('userID').then((userId) => {
							this.portfolioToken = token;
							this.portfolioUserId = this.ciphetText.aesEncrypt(userId);
						})
						
					})
				}
	
			})
		} else {
			if(localStorage.getItem('portfolioToken') == undefined){
				let id = this.cookieService.get('CC');
						let token = this.cookieService.get('.ASPXAUTH');
						this.isApkWebView = this.cookieService.get('isMobileNative') == 'Y'
						localStorage.setItem('portfolioId',id);
						localStorage.setItem('portfolioToken',token);
			}
			
			this.portfolioToken = '.ASPXAUTH='+localStorage.getItem('portfolioToken');
			this.portfolioUserId = ""
			this.portfolioId = localStorage.getItem('portfolioId');
			if(!(this.portfolioToken && this.portfolioId)){
				this.router.navigate(['/not-found']);
				return;
			}
		}

		setTimeout(() => {
			this.getFamilyDropdown();
		}, 1500);

		
		
		localStorage.removeItem('saveOtp');
		localStorage.removeItem('memberCount');
		});
		
		
	}
  profileDetails:any = [];
	clientMobNo:any;
	clientEmail:any;
	activeSegment:any;
	familyMappList:any=[];
	
	getFamilyDropdown() {
		let clientID = this.ciphetText.aesEncrypt(this.clientId);	
		this.subscription.add(
			this.clientService.getFamilyMapping(this.portfolioToken, clientID, this.portfolioUserId)
				.subscribe(async (res: any) => {
					if(res['Head']['ErrorCode'] == 0){
						this.dataLoad = false;
						if(res['Body']['FamillyMapp'].length > 0){
							
							if(res['Body']['FamillyMapp'][0]['Successflag'] == 'N'){
								this.familyMappList = [];
							}
							else{
								this.familyMappList = res['Body']['FamillyMapp'];
								this.familyMappList.forEach((element:any) => {
									element.Relation = element.Relation && element.Relation.length >  0 ? element.Relation : 'SELF';
								})
								 const selectedData = this.familyMappList.filter((temp:any)=> temp.ClientCode.toLowerCase() == this.clientId.toLowerCase())
								 this.selectedClient = selectedData[0];
								 await this.fetchExternalHoildingSummary();
								 const clientCodeList:any = []
								 this.familyMappList.forEach((user:any)=> clientCodeList.push(user.ClientCode))
								 await this.checkConsentAndData(clientCodeList)
							}
							
						}
						else{
							this.familyMappList = [];
						}
						
					}
				}, (error: any) => {
					this.familyMappList = [];
					this.dataLoad = false;
				})
		)
	}

	

	verifyMember(){
if(this.isPartner === 'true'){
						this.commonService.setClevertapEvent( 'AAA_Addfamilymember_clicked', 
			{  'Login ID': localStorage.getItem('userId1'), 'Family Relation': this.selectRelation });
		}

		let selfCode = this.familyMappList.filter((temp:any)=> temp.Relation === 'SELF' || temp.Relation === '')
			let params = {
				"Type": "Verify",
				"FamilyName": this.memberClientCode,
				"MakerID": selfCode.length > 0 ? selfCode[0].ClientCode : this.clientId,
				"Relation": this.selectRelation,
				"OTP": this.otpInput
			}
			this.subscription.add(
				this.clientService.getMemberDetails(params,this.portfolioToken)
					.subscribe((res: any) => {
						if(res['Head']['ErrorCode'] == 0){
							this.toast.displayToast(res['Body']['SuccessMsg'])
							const ele1 = document.getElementById('memberPop') as HTMLInputElement;
							ele1.style.display = 'none';
							this.display1 = false;
							this.display2 = false;
							this.display3 = true;
						}
						else{
							this.toast.displayToast(res['Body'] ? res['Body']['ErrorDescription'] : res['Head']['ErrorDescription'])
						}
					})
			)
		
	}

	removeMember(data: any){
		let params = {
			"Type": "Delete",
			"FamilyName": data.ClientCode,
			"MakerID": this.clientId,
			"Relation": data.Relation,
			"OTP": ""
		}
		this.subscription.add(
			this.clientService.getMemberDetails(params,this.portfolioToken)
				.subscribe((res: any) => {
					if(res['Head']['ErrorCode'] == 0){
						this.toast.displayToast(res['Body']['SuccessMsg'])
						this.getFamilyDropdown();
						
					}
					else{
						this.toast.displayToast(res['Body']['ErrorDescription'])
					}
				})
		)
	}

	async generateEdgeToken (){
		try {
			let selfCode = this.familyMappList.filter((temp:any)=> temp.Relation === 'SELF' || temp.Relation === '');
			selfCode = selfCode[0]?.ClientCode;
			const isPartner = this.isPartner == 'true' ? true : false;
			const username = isPartner ? localStorage.getItem('userId1') : (selfCode || this.clientId);
			if (!username) {
				throw new Error('Username not available for token generation');
			}
			const env = await this.storage.get('envSettings');
			if (!env?.ieSecret?.key) {
				throw new Error('Environment secret key not available');
			}
			const ieSecurityObj:any = await this.ciphetText.generateChecksumforInvestEdge(username, env.ieSecret.key);
			const obj = {
				"username": username,
				"timestamp": ieSecurityObj.timestamp,
				"nonce": ieSecurityObj.nonce,
				"checksum": ieSecurityObj.checksum
			};
			const res: any = await firstValueFrom(this.clientService.signedTokenforInvestEdge(obj));
			if (!res?.access) {
				throw new Error('Signed token not received');
			}
			return res.access;
		} catch (error:any) {
			this.errorDisplay(error);
			throw error;
		}
	}

	copyMessage(val: any){
		const selBox = document.createElement('textarea');
		selBox.style.position = 'fixed';
		selBox.style.left = '0';
		selBox.style.top = '0';
		selBox.style.opacity = '0';
		selBox.value = val;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
		this.toast.displayToast('Copied');
	  }

	getShortName(value: any){
		if(value && value.length){
			var shortName = value.match(/\b(\w)/g); // ['J','S','O','N']
			return shortName.join('');
		}

	}

	async checkConsentAndData(clientCode: any) {
		let count = 0;
		try {
		  const signedToken = await this.generateEdgeToken();
		  if (!signedToken) {
			throw new Error('Signed token unavailable');
		  }
	  
		  // Use a for...of loop instead of forEach
		  for (const code of clientCode) {
			const res: any = await firstValueFrom(
				this.clientService.getConsent(signedToken, code.toUpperCase(),this.isPartner == 'true' ? true:false)
			);
			// Update the consent data for each client in the correct position
			const consentData = {
			  "has_mf_consent": res?.has_mf_consent || false,
			  "has_mf_portfolio": res?.has_mf_portfolio || false,
			  "has_stock_consent": res?.has_stock_consent || false,
			  "has_stock_portfolio": res?.has_stock_portfolio || false,
			  "last_stock_update" :  res?.last_stock_update || false,
			  "last_mf_update" :  res?.last_mf_update || false,
			};
	  
			if (this.familyMappList[count].Relation === 'SELF') {
			  this.selectedClient.consentData = consentData;
			} else {
			  this.familyMappList[count].consentData = consentData;
			}
	  
			count++;
		  }
		  
		} catch (error: any) {

			const consentData = {
				"has_mf_consent": false,
				"has_mf_portfolio":  false,
				"has_stock_consent":  false,
				"has_stock_portfolio":  false,
				"last_stock_update" :  false,
				"last_mf_update" :  false,

			  };
			if (this.familyMappList[count].Relation === 'SELF') {
				this.selectedClient.consentData = consentData;
			  } else {
				this.familyMappList[count].consentData = consentData;
			  }
		
			  count++;
		}
	  }

	async refreshExternalStockData(ClientCode:any,Pan:any,PartnerCode:any){
		if(this.isPartner === 'false'){
						this.commonService.setClevertapEvent( 'Refresh_Stocks' , 
			{'Login ID' :this.clientId});
		} else {

			this.commonService.setClevertapEvent('AAA_Refresh_Stocks',
					{ 'Login ID':localStorage.getItem('userId1') ,'Client ID':ClientCode }) 

			if((this.userType == 'RM' || this.userType == 'FN'|| this.userType === 'SB') && this.isPartner == 'true'){

				this.cleverTabAndAppflyerEvent('ExternalPortfolio_RefreshstocksClicked')
			} else {
				this.cleverTabAndAppflyerEvent('Cl_ExternalPortfolio_RefreshstocksClicked')
			} 
		}
		try {

			const signedToken   = await  this.generateEdgeToken()
			const obj= {
				client: ClientCode,
				pan_no: Pan,
				manager: PartnerCode
			}
			this.clientService.refreshExternalStockData(signedToken,obj,this.isPartner == 'true' ? true:false).subscribe((res:any)=>{
					this.toast.displayToast('Holdings updated successfully')
					setTimeout(()=>{
						location.reload()
					},1000)
			}, error=>{
				this.errorDisplay(error)
			})

		} catch (error:any){
			this.errorDisplay(error)
		}
	}
	
	async generateExternalConnectLink(ClientCode:any,name:any){
		if(this.isPartner === 'false'){
							this.commonService.setClevertapEvent( 'Refresh_MF' , 
				{ 'Login ID' : this.clientId});
			} else {
				name == ''?
			this.commonService.setClevertapEvent('AAA_AddDemat_Clicked',
					{ 'Login ID':localStorage.getItem('userId1'), 'Client ID':ClientCode }) :
						this.commonService.setClevertapEvent( 'AAA_Refresh_MF',
					{ 'Login ID': localStorage.getItem('userId1'), 'Client ID':ClientCode }) ;
					

				if(name){
					this.cleverTabAndAppflyerEvent('ExternalPortfolio_RefreshMFClicked')
				} else {
					this.cleverTabAndAppflyerEvent('ExternalPortfolio_Initiated')
				}
				
			}
		try {
			let clientCode = this.familyMappList[0].ClientCode;

			if(this.familyMappList.length == 0){
				clientCode = this.clientId
			}

			localStorage.setItem('familyListConnected', clientCode);
			const data:any = await this.setSelectedClient(ClientCode)
			const signedToken   = await  this.generateEdgeToken()
			const name = this.commonService.splitName(data?.ClientName);
			const obj= {
				first_name:name.first_name,
				last_name:name.last_name,
				client: data?.ClientCode,
				pan_no: data?.ClientPanno,
				email: data?.ClientEmail,
				manager: this.isPartner == 'false' ? data?.RMCode : localStorage.getItem('userId1'),
				mode: this.isPartner == 'true' ? 'AAA' : '360'
			}
			this.clientService.generateExternalConnectLink(signedToken,obj,this.isPartner == 'true' ? true:false).subscribe((res:any)=>{
				if(res?.link){
					this.cookieService.set('beyond','true');
					if (this.commonService.isApp()) {
						var ref = cordova.InAppBrowser.open(res.link, "_blank","hidden=no,location=no,clearsessioncache=yes,clearcache=yes");
					}
					else{
						const anchor = document.createElement('a');
						anchor.href = res?.link;
						anchor.click();
					}
				}
			}, error=>{
				this.errorDisplay(error)
			})

		} catch (error:any){
			this.errorDisplay(error)
		}
	}

	async setSelectedClient(getClientCode:any) : Promise<any>{
		let requestorCode = ""
		const data = this.familyMappList.filter((temp: any ) => temp.ClientCode === getClientCode)
		var obj = { 
			"UserCode": getClientCode, "UserType": "4", "ClientType": "" , 'RequestorCode' : data[0].PartnerCode
		}
		
		return new Promise((resolve, reject) => {
			this.storage.get('envSettings').then(env => {
			this.wireReqService.getProfileDetails(this.portfolioToken, obj, env).subscribe(
				(res: any) => {
					if (res['Head']['ErrorCode'] === 0) {
						resolve(res['Body']);  // Resolve the Promise with the response body
					} else {
						reject('Error in response');  // Reject if there's an error code
					}
				},
				(error) => {
					reject(error);  // Reject the Promise in case of an error
				}
			);
		})
		});
	}

	async 	fetchExternalHoildingSummary(){
		try {
			const signedToken   = await  this.generateEdgeToken()
			if (!signedToken) {
				throw new Error('Signed token unavailable')
			}
			for(let i =0; i < this.familyMappList.length; i++){
				const res: any = await firstValueFrom(
					this.clientService.fetchExternalHoildingandSummary(signedToken,this.familyMappList[i].ClientCode.toUpperCase(),true,this.isPartner == 'true' ? true:false)
				)
				if(res){
					const data:any = res;
					this.chartDisplay2External(data,i)
				}
			}
			

		} catch (error:any){
			// this.errorDisplay(error)
		}
		
		
	}

	chartDisplay2External(array:any,i:any) {
		this.familyMappList[i].TotalValue = array.reduce((accumulator:any, current:any) => parseInt(accumulator) + parseInt(current.market_value), 0)
		let groupedKeys = lodash.groupBy(array, (item) => item.broker_name !== null ? item.broker_name.toLowerCase() : 'Direct');
		const keys = Object.keys(groupedKeys)
		this.familyMappList[i].externalBrokerList =[]
		for(let item of keys) {
			let data = 0
			data = groupedKeys[item].reduce((accumulator:any, current:any) => parseInt(accumulator) + parseInt(current.market_value), 0)
			
			this.familyMappList[i].externalBrokerList.push({name:item,total:data})
		}
	}

	cleverTabAndAppflyerEvent(name:any){
		if((this.userType == 'RM' || this.userType == 'FN'|| this.userType === 'SB') && this.isPartner == 'true'){
			this.commonService.triggerAppsflyerLogEvent(name, { 'Login ID': localStorage.getItem('userId1') });
			this.commonService.analyticEvent(name, 'Portfolio+' );
		} else {
			this.commonService.triggerAppsflyerLogEvent(name, { 'Login ID': localStorage.getItem('userId1') });
			this.commonService.analyticEvent(name, 'Portfolio+' );
		}
	  }

	  errorDisplay(error:any){
		const keys = Object.keys(error?.error?.error?.details)
		let item:any = []
		for(let key of keys){
			if(key == 'pan_no'){
				if(typeof error?.error?.error?.details[key][0] === 'string') {
				item.push({key: key,value:error?.error?.error?.details[key]})

				} else {
				item.push({key: key,value:error?.error?.error?.details[key][0]})

				}

			} else {
				item.push({key: key,value:error?.error?.error?.details[key]})
			}
		}
		let message = ''
		for(let msg of item){
			message = msg.value 
		}
		this.toast.displayToast(message)
	  }

}

